import { Toast } from "primereact/toast";
import { useContext, useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { InputSwitch } from "primereact/inputswitch";

import {
  allMonths,
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  quaters,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { PDAReportListColumns } from "../../appconfig/DatatableSetting";
import {
  GET_PD7A_REPORT,
  PAID_STATUS,
  GENERATE_CUSTOM_RANGE_PD7A,
} from "../../config/ApiConstant";
import {
  getThreeDetailsById,
  postAllData,
  postDataByID,
} from "../../service/ProductService";
import { Card } from "primereact/card";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { Badge } from "primereact/badge";
import { Dialog } from "primereact/dialog";

const PayrollReports = () => {
  document.title = "PD7A | Nexawage Payroll";
  const toast = useRef<any>(null);
  const navigate = useNavigate();
  const { id }: any = useParams();
  const client_id = id
    ? (() => {
      try {
        return atob(id);
      } catch {
        return null;
      }
    })()
    : null;
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [pdfList, setPdfList] = useState<any>([]);
  const [selectedQuater, setSelectedQuater] = useState<any>("Monthly");
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);


  const [customMonthDialog, setCustomMonthDialog] = useState<boolean>(false);
  const [customFromMonth, setCustomFromMonth] = useState<any>(null);
  const [customToMonth, setCustomToMonth] = useState<any>(null);
  const [pdfDownloadLoading, setPdfDownloadLoading] = useState<boolean>(false);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const clientId = userData?.id;
  const userRole = userData?.roles?.role_name || "";

  // paid status
  const [paidStatus, setPaidStatus] = useState<any>(null);
  const [paidPd7aListId, setPaidPd7aListId] = useState<any>(null);
  const [isHold, setIsHold] = useState<any>(null);
  const [paidDialog, setPaidDialog] = useState<boolean>(false);

  // useefect for get user list
  useEffect(() => {
    getListEmployee();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear, selectedQuater]);

  // list-employee
  const getListEmployee = async () => {
    setPageLoad(false);
    let idToSend;
    if (userRole === "User") {
      idToSend = client_id;
    } else if (userRole === "Client") {
      idToSend = clientId;
    }
    try {
      const response = await getThreeDetailsById(
        GET_PD7A_REPORT,
        "",
        idToSend,
        "year",
        selectedYear,
        "quarter",
        selectedQuater
      );

      const data = response;
      if (data) {
        setPdfList(data);
        setPageLoad(true);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // clear all filter
  const clearAll = () => {
    setSelectedYear(currentYear);
    setGlobalFilter(null);
    setGlobalFieldFilter(null);
    setSelectedQuater("Monthly");
  };

  // open / hide custom month modal
  const openCustomMonthDialog = () => {
    setCustomFromMonth(null);
    setCustomToMonth(null);
    setCustomMonthDialog(true);
  };

  const hideCustomMonthDialog = () => {
    setCustomMonthDialog(false);
    setCustomFromMonth(null);
    setCustomToMonth(null);
  };

  // download pdf for custom month range
  const downloadCustomMonthPdf = async () => {
    if (!customFromMonth || !customToMonth) {
      toast.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select both From Month and To Month.",
      });
      return;
    }
    setPdfDownloadLoading(true);
    let idToSend;
    if (userRole === "User") {
      idToSend = client_id;
    } else if (userRole === "Client") {
      idToSend = clientId;
    }
    // Format months as MM/YYYY e.g. "03/2026"
    const pad = (n: number) => String(n).padStart(2, "0");
    const startMonth = `${pad(customFromMonth)}/${selectedYear}`;
    const endMonth = `${pad(customToMonth)}/${selectedYear}`;
    try {
      const response: any = await postAllData(GENERATE_CUSTOM_RANGE_PD7A, {
        client_id: idToSend,
        start_month: startMonth,
        end_month: endMonth,
      });
      const pdfUrl =
        response?.pd7a_url || response?.pdf_url || response?.url || null;

      if (pdfUrl) {
        // Fetch as blob so it downloads instead of opening in a new tab
        const fileRes = await fetch(pdfUrl);
        const blob = await fileRes.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        // Derive a filename from the URL, fallback to pd7a_report.pdf
        a.download =
          pdfUrl.split("/").pop()?.split("?")[0] || "pd7a_report.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(blobUrl);
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "PDF could not be generated.",
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message || "Failed to download PDF.",
      });
    } finally {
      setPdfDownloadLoading(false);
    }
  };

  // handle custom from month change
  const handleCustomFromMonthChange = (e: any) => {
    setCustomFromMonth(e.value);
    if (customToMonth && e.value > customToMonth) {
      setCustomToMonth(null);
    }
  };

  // get formatted months for dropdown options
  const getFormattedAllMonths = () => {
    return allMonths.map((m) => ({
      label: `${String(m.value).padStart(2, "0")}/${selectedYear}`,
      value: m.value,
    }));
  };

  const getFormattedToMonths = () => {
    return allMonths
      .filter((m) => !customFromMonth || m.value >= customFromMonth)
      .map((m) => ({
        label: `${String(m.value).padStart(2, "0")}/${selectedYear}`,
        value: m.value,
      }));
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          value={globalFilter || ""}
          onInput={(e) => setGlobalFilter(e.currentTarget.value)}
          placeholder="Search..."
        />
      </span>

      <Dropdown
        value={selectedQuater || ""}
        onChange={(e) => {
          if (e.value === "CustomMonth") {
            openCustomMonthDialog();
          } else {
            setSelectedQuater(e.value);
          }
        }}
        options={quaters}
        placeholder="Select Quater"
        className="mr-3 w-15rem"
      />
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <>
      <Button
        icon="pi pi-filter-slash"
        label="Clear"
        onClick={clearAll}
        className="mr-2 p-button-outlined common-p-outline-button"
      />

      <Calendar
        value={moment(String(selectedYear), "YYYY").toDate()}
        view="year"
        dateFormat="yy"
        onChange={(e: any) => {
          const year = moment(e.value).year();
          if (year) setSelectedYear(year);
        }}
        showIcon
        placeholder="Select Year"
        className="ml-2 w-11rem"
      />
    </>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData.pd7a_url) {
      window.open(rowData.pd7a_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  const paymentUrlBodyTemplate = (rowData: any) => {
    // external link
    const paymentLink =
      "https://apps.cra-arc.gc.ca/ebci/fppp/mypymnt/pub/ntr.action";

    // external link navigate
    const navigateToExternalLink = () => {
      window.open(paymentLink, "_blank");
    };
    return (
      <div className="name">
        <Button
          tooltip="Payment"
          className="ml-2 common-primary-button"
          icon="pi pi-credit-card"
          label=""
          onClick={navigateToExternalLink}
        />
      </div>
    );
  };

  // paid status api call
  const paidStatusSend = async () => {
    try {
      //call api
      const response = await postDataByID(PAID_STATUS, paidPd7aListId);

      if (response) {
        setPaidDialog(false);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
        getListEmployee();
        setPageLoad(true);
      }
    } catch (error: any) {
      setPageLoad(false);
      setPaidDialog(false);
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // close paidStatus model
  const hidePaidDialog = () => {
    setPaidDialog(false);
    setPaidPd7aListId(null);
    setPaidStatus(null);
  };

  // onchange paid status
  const onPaidStatusChange = (rowData: any, e: any) => {
    setPaidPd7aListId(rowData?.id);
    setPaidDialog(true);
    if (rowData.status === false) {
      setIsHold(false);
    } else {
      setIsHold(true);
    }
  };

  // activate Template
  const paidStatusTemplate = (rowData: any) => {
    const isPaid = rowData?.status === true;
    return (
      <div className="actions flex flex-column align-items-center">
        <InputSwitch
          className="mr-2 mb-2"
          value={paidStatus}
          checked={isPaid}
          onChange={(e) => onPaidStatusChange(rowData, e)}
          disabled={isPaid || (selectedQuater === "Monthly" ? false : true)}
        />
        {selectedQuater === "Monthly" ? (
          <Badge
            severity={isPaid ? "success" : "danger"}
            value={isPaid ? "Paid" : "Unpaid"}
            style={{ width: "fit-content" }}
          ></Badge>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="PD7A Reports"
        pageName="PD7A Report List"
        pageTitle={
          !!client_id ? (
            <div className="gotopage-button-header">
              <Button
                icon="pi pi-arrow-left"
                className="mr-2 common-p-gotopage-button"
                onClick={() => navigate("/clients")}
              />
              <span className="span-text">PD7A Report List</span>
            </div>
          ) : (
            " PD7A Report List"
          )
        }
      />
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white crud-demo lg:p-2">
            <Toast ref={toast} />
            <Toolbar
              className="gap-3"
              left={leftToolbarTemplate}
              right={rightToolbarTemplate}
            />
            {pageLoad ? (
              <DataTable
                value={pdfList}
                showGridlines
                dataKey="id"
                stripedRows
                globalFilter={globalFilter}
                rows={defaultRowOptions}
                paginator={pdfList.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " PD7A Report"}
                emptyMessage="No PD7A Report Found"
                filters={globalFieldFilter}
                onFilter={(e) => setGlobalFieldFilter(e.filters)}
                removableSort
                responsiveLayout={"scroll"}
              >
                {PDAReportListColumns.map((col, i) => {
                  if (col.field === "pd7a_url") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={actionBodyTemplate}
                      />
                    );
                  } else if (col.field === "period") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  } else if (col.field === "status") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={paidStatusTemplate}
                      />
                    );
                  } else if (col.field === "payment_url") {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={paymentUrlBodyTemplate}
                      />
                    );
                  } else {
                    return (
                      <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                      />
                    );
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {PDAReportListColumns.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    body={SkeletonbodyTemplate}
                  />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* paidStatus modal start*/}
      <Dialog
        visible={paidDialog}
        style={{ width: "450px" }}
        header="Payment Status"
        modal
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hidePaidDialog}
            />
            <Button
              label="Submit"
              icon="pi pi-arrow-up-right"
              className="p-button-success"
              onClick={paidStatusSend}
              loading={submitLoading}
            />
          </>
        }
        onHide={hidePaidDialog}
      >
        <div className="flex align-items-center justify-content-start">
          <i
            className="pi pi-exclamation-triangle mr-3 delete-triangle"
            style={{ fontSize: "2rem" }}
          />
          {isHold === false ? (
            <span className="delete-dialog-note">
              Note: OnSubmit Payment Status Will be changed to Paid.
            </span>
          ) : (
            ""
          )}
        </div>
      </Dialog>
      {/* paid status eModal End*/}

      {/* Custom Month PDF Modal */}
      <Dialog
        visible={customMonthDialog}
        style={{ width: "480px" }}
        header={
          <span>
            <i className="pi pi-calendar mr-2" />
            Custom Month Range
          </span>
        }
        modal
        onHide={hideCustomMonthDialog}
        footer={
          <>
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideCustomMonthDialog}
            />
            <Button
              label="Generate PDF"
              icon="pi pi-download"
              className="common-primary-button"
              onClick={downloadCustomMonthPdf}
              loading={pdfDownloadLoading}
              disabled={!customFromMonth || !customToMonth}
            />
          </>
        }
      >
        <div className="p-fluid">
          <p className="mt-0 mb-3 text-color-secondary" style={{ fontSize: "0.9rem" }}>
            A combined PD7A will be generated for selected months.
          </p>
          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="block mb-2 font-semibold">From Month</label>
              <Dropdown
                value={customFromMonth}
                onChange={handleCustomFromMonthChange}
                options={getFormattedAllMonths()}
                optionLabel="label"
                optionValue="value"
                placeholder="Select From Month"
                className="w-full"
              />
            </div>
            <div className="col-12 md:col-6">
              <label className="block mb-2 font-semibold">To Month</label>
              <Dropdown
                value={customToMonth}
                onChange={(e) => setCustomToMonth(e.value)}
                options={getFormattedToMonths()}
                optionLabel="label"
                optionValue="value"
                placeholder="Select To Month"
                className="w-full"
                disabled={!customFromMonth}
              />
            </div>
          </div>
          {customFromMonth && customToMonth && (
            <div
              className="mt-3 p-3 border-round"
              style={{ background: "var(--surface-100, #f8f9fa)", borderLeft: "4px solid var(--primary-color, #6366f1)" }}
            >
              <i className="pi pi-info-circle mr-2 text-primary" />
              <span className="font-medium">
                {String(customFromMonth).padStart(2, '0')}/{selectedYear} —{" "}
                {String(customToMonth).padStart(2, '0')}/{selectedYear}
              </span>
            </div>
          )}
        </div>
      </Dialog>
      {/* Custom Month PDF Modal End */}
    </>
  );
};
export default PayrollReports;
